<template>
  <el-dialog  class="developing_model_dialog" top="5vh" center
    :title="'其他任务-【' + formInfo.id + '】' + formInfo.title" width="90%"
    :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form ref="form" size="mini" :rules="rules" :model="formInfo">
      <el-form-item label="任务内容"  prop="details" :label-width="formLabelWidth" >
        <Editor  :content="formInfo.context" @contentData="changeContent"
                :dialogVisibleModelType="formInfo.id ? 'update' : 'create'" />
      </el-form-item>
      <div style="display: flex;">
        <el-form-item label="任务类型" :label-width="formLabelWidth">
          <div style="white-space: nowrap;"> {{allSelect.OTHERTASHOPERATOR[formInfo.task_type]}}</div>
        </el-form-item>
        <el-form-item label="需求人" :label-width="formLabelWidth">
          <div style="white-space: nowrap;">{{ allSelect.TEXTUSERS[formInfo.demander] }}</div>
        </el-form-item>
        <el-form-item label="优先级" label-width="262px">
          <div style="white-space: nowrap;">{{formInfo.priority}}</div>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="负责人" label-width="187px">
          {{allSelect.TEXTALLUSERSEN[formInfo.leading]}}
        </el-form-item>
        <el-form-item label="计划开始日期" label-width="140px">
          {{ formatTimeToDate(formInfo.plt * 1, "YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
        <el-form-item label="计划完成日期" label-width="150px">
          {{ formatTimeToDate(formInfo.plet * 1, "YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
      </div>
      <div style="display: flex;">
      <el-form-item label="状态" label-width="175px">
        {{ allSelect.OTHERTASKSTATUS[formInfo.status] }}
      </el-form-item>
      <el-form-item label="创建人" label-width="210px">
        <div style="white-space: nowrap;">{{allSelect.TEXTALLUSERSEN[formInfo.username]}}</div>
      </el-form-item>
      <el-form-item label="创建时间" label-width="165px">
        <div style="white-space: nowrap;">{{ formatTimeToDate(formInfo.create_time * 1, "YYYY-MM-DD HH:mm:ss") }}</div>
      </el-form-item>
      </div>
      <el-form-item label="我做了啥"  prop="operator_context" :label-width="formLabelWidth" >
        <Editor   :content="formInfo.operator_context" @contentData="changeContent"
                 :dialogVisibleModelType="formInfo.id ? 'update' : 'create'" />
      </el-form-item>

      <el-form :model="formInfo" v-if="formInfo.id">
        <el-form-item class="comment_warp" label="评论" :model="formInfo" :label-width="formLabelWidth">
          <Comment  :tid="String(formInfo.id)" type="other_task" />
        </el-form-item>
      </el-form>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="loading.toSave" @click="submit('save')">保存</el-button>
      <el-button type="warning" :loading="loading.toSave" @click="submit('sumbit')">提 交</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { Editor } from "@/components/index.js";
import {
  postDevOpsSpaceUpdateOtherTaskApi,
  getDevOpsSpaceOtherDetailApi
} from "@/server/tops/devOps";
import {
  formatDate,
  formatTimeToDate,
} from "@/views/tops/devOps/components/util.js";
import { mapState, mapMutations } from "vuex";
import Comment from '@/views/tops/devOps/producerSpace/components/comment.vue'
export default {
  components: { Editor, Comment },
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { };
      },
    },
  },
  data() {
    return {
      form: {
        id: "",
      },
      rules: {
        operator_context: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: "200px",
      dialog: {

      },
      loading: {
        toSave: false,
      },
      is_admin: 0, // 0 不是管理员 1 是管理员
    };
  },
  async created() {
    await this.getOtherDetailApi();
  },
  computed: {
    ...mapState({
      allSelect: (state) => state.devOps.ALLSELECT,
    }),
  },
  updated() {
  },
  methods: {
    ...mapMutations(['setProgressBar', 'openWebSocket', 'sendWebSocket', 'closeWebSocket', 'scrollToBottom']),
    // 获取详情
    async getOtherDetailApi() {
      const { id = "" } = this.formInfo || {};
      try {
        const ret = await getDevOpsSpaceOtherDetailApi({
          id: id,
        });
        const info = ret.data[0] || {};
        this.formInfo = {
          ...this.formInfo,
          demander: info.demander,
          creator: info.username,
          title: info.title,
          task_type: info.task_type,
          status: info.status,
          project_system: info.project_system,
          priority: info.priority,
          plt: info.plt,
          plet: info.plet,
          operator_context: info.operator_context,
          leading: info.leading,
          context: info.context,
          create_time: info.create_time,
        };
      } catch (error) {
        this.$notify({
          message: error || "获取详情失败",
          type: "error",
        });
      }
    },
    // 修改富文本内容
    changeContent(val) {
      this.formInfo.operator_context = val;
    },
    // 关闭弹窗
    handleClose(step) {

      this.hideDialogVisible(step);
    },
    // 提交
    async submit(action) {
      this.$refs["form"].validate(async (valid) => {
        if(valid){
          const loginusername = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
          try {
            const {
              id = "",
              title = "",
              leading = "",
              username = "",
              operator_context = "",
            } = this.formInfo;


            const param = {
              id: id,
              leading: leading,
              creator: username,
              username: loginusername,
              operator_context:operator_context,
              flag: action,
              title: title,
            };
            if(action == 'save'){
              delete param.creator
              delete param.title
            }
            const ret = await postDevOpsSpaceUpdateOtherTaskApi(param);
            if (ret.status === 'success') {
              this.handleClose();
              this.$notify({
                message: ret.data?.msg || "提交成功",
                type: "success",
              });
            } else {
              this.$notify({
                message: ret.data?.msg || "提交失败",
                type: "error",
              });
            }
          } catch (error) {
            this.msg.toTestMsg = error || "数据错误";
          } finally {
            this.loading.toSave = false;
          }
        }
      })

    },
    formatTimeToDate
  },
};
</script>
<style lang="scss">
.developing_model_dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
}

.developing_model_dialog_child {
  .el-dialog__body {
    padding: 0 20px 10px;
  }
}
.el-form-item--mini .el-form-item__content, .el-form-item--mini .el-form-item__label {
  line-height: 16px;
}
</style>